import React from "react";
import { Navbar, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
//css
import "../../App.css";

export default function TopNav() {
  return (
    <Navbar collapseOnSelect expand="lg" className="navbarColour" sticky="top">
      <Container className="container-fluid">
        <NavLink to="/" className="navbar-brand navitemColour">
          <img
            className="navbarLogo me-5"
            src={require("../../Assets/LightNighthawkLogo.jpg")}
          />
        </NavLink>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <h1 className="navbarHeader">Financial Forecaster</h1>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
